import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-new-organization',
  templateUrl: './new-organization.component.html',
  styleUrl: './new-organization.component.css'
})
export class NewOrganizationComponent implements OnInit {
  optionsMap: { [key: string]: any[] } = {
    countries: [{ value: 'India', label: 'India' }],
    states: [],
    districts: [],
    orgType: [
      { value: 'cooperative', label: 'Cooperative (Co-op)' },
      { value: 'corporation', label: 'Corporation' },
      { value: 'franchise', label: 'Franchise' },
      { value: 'government_organization', label: 'Government Organization' },
      { value: 'joint_venture', label: 'Joint Venture' },
      { value: 'opc', label: 'One Person Company (OPC)' },
      { value: 'partnership', label: 'Partnership' },
      { value: 'private_limited', label: 'Private Limited Company (Pvt Ltd)' },
      { value: 'psu', label: 'Public Sector Undertaking (PSU)' },
      { value: 'public_limited', label: 'Public Limited Company (Ltd)' },
      { value: 'sole_proprietorship', label: 'Sole Proprietorship' },
      { value: 'trust', label: 'Trust' }
    ],
    domainOptions: [
      { value: 'Residential', label: 'Residential' },
      { value: 'Commercial', label: 'Commercial' },
      { value: 'Educational', label: 'Educational' },
      { value: 'Water', label: 'Water' },
      { value: 'Power', label: 'Power' },
      { value: 'Gas', label: 'Gas' },
      { value: 'Telecom', label: 'Telecom' },
      { value: 'Road', label: 'Road' },
      { value: 'Consultancy', label: 'Consultancy' }
    ]
  };


  orgFormFields = [
    { key: 'org_name', label: 'Organization Name', type: 'text', value: '', required: true },
    { key: 'company_code', label: 'Company Code', type: 'text', value: '', required: false },
    { key: 'org_type', label: 'Organization Type', type: 'select', value: '', optionKey: 'orgType', required: true },
    { key: 'primary_contact_name', label: 'Primary Contact Name', type: 'text', value: '', required: false },
    { key: 'primary_contact_phone', label: 'Primary Contact Phone', type: 'text', value: '', required: false },
    { key: 'primary_contact_email', label: 'Primary Contact Email', type: 'email', value: '', required: false },
    { key: 'domain', label: 'Domain', type: 'select', multiple: true, value: '', optionKey: 'domainOptions', required: true },
    { key: 'registration_number', label: 'Registration Number', type: 'text', value: '', required: false },
    { key: 'gst_number', label: 'GST Number', type: 'text', value: '', required: true, validators: [Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')] },
    { key: 'pan_number', label: 'PAN Number', type: 'text', value: '', required: true, validators: [Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')] },
    { key: 'country', label: 'Country', type: 'select', value: '', optionKey: 'countries', onChange: () => this.onCountryStateChange(), required: true },
    { key: 'state', label: 'State', type: 'select', value: '', optionKey: 'states', onChange: () => this.onStateChange(), required: true },
    { key: 'city', label: 'City', type: 'select', value: '', optionKey: 'districts', required: true },
    { key: 'postal_code', label: 'Postal Code', type: 'text', value: '', required: true },
    { key: 'address_line_1', label: 'Address Line 1', type: 'text', value: '', required: true },
    { key: 'address_line_2', label: 'Address Line 2', type: 'text', value: '', required: true },
    { key: 'org_logo', label: 'Organization Logo', type: 'file', value: null, required: false },
    { key: 'additional_branch', label: 'Additional Branch', type: 'checkbox', value: false, required: false },

  ];

  empformFieldata = [
    { key: 'full_name', label: 'Full Name', type: 'text', value: '', required: true },
    { key: 'contact_email', label: 'Contact Email', type: 'email', value: '', required: true },
    { key: 'contact_phone', label: 'Contact Phone', type: 'tel', value: '', required: true, pattern: '^[0-9]{10}$' },
    { key: 'companyName', label: 'Company Name', type: 'text', value: '', required: false },
    { key: 'companyId', label: 'Company ID', type: 'text', value: '', required: false },
    { key: 'branchName', label: 'Branch Name', type: 'text', value: '', required: false },
    { key: 'branchId', label: 'Branch ID', type: 'text', value: '', required: false },
    { key: 'employeeId', label: 'Employee ID', type: 'text', value: '', required: true, pattern: '^[a-zA-Z0-9]+$' },
    { key: 'emergencyContact', label: 'Emergency Contact', type: 'text', value: '', required: false, maxLength: 100 },
    { key: 'role', label: 'Role', type: 'text', value: '', required: true },
    { key: 'hireDate', label: 'Hire Date', type: 'date', value: '', required: true },
    { key: 'jobRole', label: 'Job Role', type: 'text', value: '', required: true },
    { key: 'designation', label: 'Designation', type: 'text', value: '', required: false, pattern: '^[a-zA-Z0-9-]+$' }
  ];

  braformFields = [
    { key: 'branch_id', label: 'Branch ID', type: 'text' },
    { key: 'branch_name', label: 'Branch Name', type: 'text', required: true },

    { key: 'org_id', label: 'Organization ID', type: 'text', readonly: true },

    { key: 'primary_contact_name', label: 'Primary Contact Name', type: 'text', required: true },
    { key: 'primary_contact_email', label: 'Primary Contact Email', type: 'email', required: true },
    {
      key: 'primary_contact_phone', label: 'Primary Contact Phone', type: 'text', required: true, pattern: /^[0-9]{10}$/
    },
    { key: 'domain', label: 'Domain', type: 'select', multiple: true, value: '', optionKey: 'domainOptions', required: true },
    { key: 'registration_number', label: 'Registration Number', type: 'text' },

    { key: 'gst_number', label: 'GST Number', type: 'text', pattern: '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$' },

    { key: 'pan_number', label: 'PAN Number', type: 'text', pattern: '^[A-Z]{5}[0-9]{4}[A-Z]{1}$' },

    { key: 'country', label: 'Country', type: 'select', value: '', optionKey: 'countries', onChange: () => this.onCountryStateChange(), required: true },
    { key: 'state', label: 'State', type: 'select', value: '', optionKey: 'states', onChange: () => this.onStateChange(), required: true },
    { key: 'city', label: 'City', type: 'select', value: '', optionKey: 'districts', required: true },





    { key: 'address_line_1', label: 'Address Line 1', type: 'text', required: true },
    { key: 'address_line_2', label: 'Address Line 2', type: 'text', required: true },
    { key: 'postal_code', label: 'Postal Code', type: 'text', required: true },

    { key: 'lat', label: 'Latitude', type: 'text', required: true },
    { key: 'long', label: 'Longitude', type: 'text', required: true },
  ];


  orgForm!: FormGroup;
  empForm!: FormGroup;
  branchForm!: FormGroup;
  organizationId = 80;

  constructor(private formBuilder: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService,
  ) { }
  ngOnInit(): void {
    this.orgForm = this.createDynamicForm(this.orgFormFields);
    this.empForm = this.createDynamicForm(this.empformFieldata);
    this.branchForm = this.formBuilder.group({
      additionalBranch: this.formBuilder.array([this.createBranchGroup()])
    });
    if (this.organizationId) {
      this.getOrganizationId();
      this.onCountryStateChange()
    }
  }

  createDynamicForm(fields: any[]): FormGroup {
    const group: any = {};
    fields.forEach(field => {
      const validators = [];
      if (field.required) validators.push(Validators.required);
      if (field.validators) validators.push(...field.validators);

      group[field.key] = this.formBuilder.control(field.value, validators);
    });
    return this.formBuilder.group(group);
  }
  onFileChange(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.orgForm.get(controlName)?.setValue(file);
      this.orgForm.get(controlName)?.markAsDirty();
    }
  }

  onCountryStateChange() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.optionsMap['states'] = (res as any[]).map(state => ({
          value: state,
          label: state
        }));
        this.orgForm.get('state')?.setValue('');
        this.optionsMap['districts'] = [];
      },
      error: (err) => this.toastrMsgService.error(err.error.errorMessage)
    });
  }

  onStateChange() {
    const selectedState = this.orgForm.get('state')?.value;
    console.log(selectedState)
    if (selectedState) {
      this.apiService.getdistricts(selectedState).subscribe({
        next: (res) => {
          this.optionsMap['districts'] = (res as any[]).map(city => ({
            value: city,
            label: city
          }));
          this.orgForm.get('district')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }
  }


  getOrganizationId() {
    this.apiService.getOrganizations({} as any).subscribe({
      next: (res: any) => {
        const data = res.data.find((org: any) => org.org_id == this.organizationId);
        if (data) {
          const patchableData: any = {};
          this.orgFormFields.forEach(field => {
            if (data.hasOwnProperty(field.key)) {
              if (field.key === 'domain') {
                patchableData[field.key] = data[field.key]
                  ? data[field.key].split(',').map((d: string) => d.trim())
                  : [];
              } else {
                patchableData[field.key] = data[field.key];
              }
            }
          });
          const empData = data.staff[0]
          if (empData) {
            const patchableEmpData: any = {};
            this.empformFieldata.forEach(field => {
              if (empData.hasOwnProperty(field.key)) {
                patchableEmpData[field.key] = empData[field.key];
              }
            });
            this.empForm.patchValue(patchableEmpData);

          }

          const formArray = this.formBuilder.array([]) as unknown as FormArray<FormGroup>;
          const formatted = data?.branches.map((branch: { domain: string; }) => ({
            ...branch,
            domain: typeof branch.domain === 'string'
              ? branch.domain.split(',').map((d: string) => d.trim())
              : branch.domain
          }));
          const lData = formatted || [];
          lData.forEach((branch: { [key: string]: any; }) => {
            const group = this.createBranchGroup();
            group.patchValue(branch);
            formArray.push(group);
          });

          this.branchForm.setControl('additionalBranch', formArray);


          setTimeout(() => {
            this.orgForm.patchValue(patchableData);
            this.onStateChange()
          }, 100);
        }
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error?.errorMessage || 'Error loading organization data');
      },
      complete: () => { }
    });
  }



  get additionalBranch(): FormArray {
    return this.branchForm.get('additionalBranch') as FormArray;
  }
  createBranchGroup(): FormGroup {
    const group: any = {};

    this.braformFields.forEach(field => {
      const validators = [];

      if (field.required) {
        validators.push(Validators.required);
      }

      if (field.pattern) {
        validators.push(Validators.pattern(field.pattern));
      }

      group[field.key] = new FormControl({ value: field.value || '', disabled: field.readonly || false }, validators);
    });

    return this.formBuilder.group(group);
  }

  addBranch() {
    this.additionalBranch.push(this.createBranchGroup());
  }

  removeBranch(index: number) {
    if (this.additionalBranch.length > 1) {
      this.additionalBranch.removeAt(index);
    }
  }

}
